
<template>
    <div>
        <slot :menu="self"></slot>
    </div>
</template>

<script>

    export default {
        name: "MainMenu",
        props: {
            
        },
        data() {
            return {
                showMainMenu   : false,           // 顯示/隱藏 主選單
            };
        },
        mounted() {
            
        },
        methods: {
            /**
             * 當 ''/'' 按鈕被點擊後 -> 顯示/隱藏 MainMenu
             */
            showHideMainMenu() {
                this.showMainMenu = !this.showMainMenu;
                
                if(this.showMainMenu){
                  document.querySelector("html").style.overflow = "hidden"
                  document.querySelector("html").style.position = "fixed"
                } else {
                  document.querySelector("html").style.overflow = ""
                  document.querySelector("html").style.position = ""
                }
            },
        },
        computed: {
            self() {
                return this;
            }
        },
    };
</script>
